import {
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { IconArrowRight, IconX } from "@tabler/icons-react";
import { Empty } from "./Empty";
import { useStudentModalStore } from "../stores/studentModal";

const StudentsIndicatorsList = ({
  data,
  open,
  title,
  onClose,
}: {
  data: any;
  title: string;
  open: boolean;
  onClose: () => void;
  refetch: () => void;
}) => {
  const openStudent = useStudentModalStore((s) => s.openModal);
  return (
    <Dialog maxWidth="sm" open={open} onClose={() => onClose()} fullWidth>
      {/* <Loading loading={} /> */}
      <DialogContent>
        <Grid2 container spacing={2}>
          <Grid2 size={12}>
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h2" fontSize={26} fontWeight={600}>
                {title}
              </Typography>
              <IconButton onClick={() => onClose()}>
                <IconX />
              </IconButton>
            </Stack>
          </Grid2>
          <Grid2 size={12}>
            <Stack gap={2}>
              {data?.map((item: any) => {
                return (
                  <Stack key={item?.id} sx={styles.cardStyle}>
                    <Stack>
                      <Typography fontWeight={700} fontSize={16}>
                        {item?.fullName}
                      </Typography>
                      {item?.nickName && (
                        <Typography
                          fontSize={12}
                          color="secondary.contrastText"
                        >
                          {item?.nickName}
                        </Typography>
                      )}
                    </Stack>
                    <IconButton
                      onClick={() => {
                        openStudent({ id: item?.id });
                        onClose();
                      }}
                    >
                      <IconArrowRight />
                    </IconButton>
                  </Stack>
                );
              })}
              <Empty data={data} title="" />
            </Stack>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  cardStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 1.5,
    borderRadius: 3,
    backgroundColor: "secondary.dark",
  },
};

export default StudentsIndicatorsList;
